module.exports = __webpack_public_path__ + "static/media/museum_logo.fffc4d93.png";